module.exports = "/_next/static/images/modularDataCenters-8d806ea38c197ed248db49da27365382.webp";